import React from 'react';
import { Link } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import {
  EmailInputField, PasswordInputField, TextInputField, SelectField, DEFAULT_REQUIRED_MESSAGE,
  EMAIL_INVALID_MESSAGE
} from 'common/components/form_fields';
import SubcategoriesField from 'common/containers/sub_categories_field';
import { validatePwdStrength } from 'common/utils';
import isEmail from 'sane-email-validation';

const AGENCY_OPTIONS = [
  { 'field': 'yes', 'label': 'Yes' },
  { 'field': 'no', 'label': 'No' }
];

const Step1Form = ({
  error, handleSubmit, submitting, submitFailed, isClient, creativeRegistrationClosed
}) => (
  <form onSubmit={handleSubmit} noValidate>
    <fieldset>
      { isClient &&
      <p>
        Your username is your public name on the site. It's how creatives will know you.
        It's important to choose something unique and professional.
      </p> }

      { !isClient && !creativeRegistrationClosed &&
      <p>
        Your username is how clients will know you on crowdspring. It's your "business name".
        It's important to choose something unique and professional.
      </p> }

      { !isClient && creativeRegistrationClosed &&
      <div>
        <p>
          We're not accepting new creative registrations right now. Please read
          our <Link target="_blank" to="/help/joining-and-verification/why-does-crowdspring-have-wait-list-register-designer-or-namer/"> Wait List FAQ</Link> to learn more.
        </p>
        <p>
          Add your email below and pick the project categories in which you have experience and
          want to participate. We'll let you know when our next open registration period starts.
        </p>
      </div> }

      { isClient &&
      <p>
        Clients cannot submit work to projects. Please register as a creative if you want to
        participate in design or naming projects as a creative.
      </p> }

      { (isClient || !creativeRegistrationClosed) &&
      <Field name="username" label="Username" component={TextInputField} /> }

      <Field name="email" label="Email Address" component={EmailInputField} />

      { (isClient || !creativeRegistrationClosed) &&
      <Field name="password" label="Create Password" indicateStrength={true}
       component={PasswordInputField} showVisibilityToggle={true} /> }

      { isClient &&
      <Field name="is_agency" label="Are you a marketing/design agency or freelancer?"
        component={SelectField} options={AGENCY_OPTIONS} allowEmpty={true} /> }

      { !isClient && creativeRegistrationClosed &&
      <Field name="intended_sub_category_ids" component={SubcategoriesField}
        label="I have experience and want to participate in the following project categories:" /> }
    </fieldset>

    <AnimatedButton processing={submitting} type="submit"
      label={isClient || !creativeRegistrationClosed? "Create account" : "Done"}
      processingLabel="Creating..." errorMsg={error || submitFailed}
      baseBtnClass="btn-tertiary btn-block"
      successMsg="Account Created!"/>
  </form>
)


const validate = values => {
  const errors = {}
  const requiredFields = ['email', 'password', 'username', 'is_agency']
  for (let f of requiredFields) {
    if (!values[f]) errors[f] = DEFAULT_REQUIRED_MESSAGE
  }

  /* validate password strength */
  if (!errors['password']) {
    errors['password'] = validatePwdStrength(values['password'])
  }

  /* validate email */
  if (!errors['email'] && !isEmail(values['email'])) {
    errors['email'] = EMAIL_INVALID_MESSAGE
  }

  if ((values.intended_sub_category_ids || []).length === 0) {
    errors['intended_sub_category_ids'] = "Please select at least one item.";
  }

  return errors
}

export default reduxForm({
  form: "Step1Form",
  validate,
})(Step1Form);



// WEBPACK FOOTER //
// ./registration/common/components/step1_form.jsx